<!--
  * @Author: changyunxia
  * @Date:2020年10月19日 10:26:36
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月19日 10:26:36
  * @Description:
  * @FilePath:@/components/myMeeting/meetingListChid.vue
-->
<template>
  <div>
    <van-swipe-cell :right-width="swipeWidth">
      <div class="myMeeting-bg">
        <div class="myMeeting-circular">
          <i class="circular" />
        </div>
        <div class="myMeeting-l-font">
          <div class="myMeeting-font-tit">
            <div class="font-color">会议室{{ ModifyData.room_code }}{{ ModifyData.create_user }}</div>
            <div>{{ time }}-{{ timEnd }}</div>
          </div>
          <div>{{ ModifyData.meeting_title }}</div>
          <!-- 周期会议 -->
          <div v-if="cycleMeet" class="myMeeting-font-tit" style=" display: block;">
            <div>
              <span v-for="(item , key ) in cycleTime" :key="key" :class="item.overdue?'red-line':''">{{ item.time }}</span>
            </div>
            <div class="font-more" @click="dialogshow=true">查看详情></div>
          </div>
          <!-- 单个会议 -->
          <div v-else class="myMeeting-font-tit">
            <div>
              <span :class="overdue?'red-line':''">{{ ModifyData.meeting_time_s }}</span>
            </div>
            <div class="font-more" @click="dialogshow=true">查看详情></div>
          </div>
        </div>
      </div>
      <template v-if="btnRShow" #right>
        <van-button v-if="updbtnShow" square text="修改" class="my-btn my-btn-bg-bule" @click="ModifyFunc" />
        <van-button v-if="delbtnShow" square text="删除" class="my-btn my-btn-bg-red" @click="delMeetingFunc()" />
      </template>
    </van-swipe-cell>
    <van-dialog v-model="dialogshow" title="会议室详情">
      <myMeetingDetails :details-data="ModifyData" :cycle-meet="cycleMeet" :cycle-time="cycleTime" />
    </van-dialog>
  </div>

<!-- DelectMeeting -->
</template>

<script>
import myMeetingDetails from '@/components/myMeeting/myMeetingDetails'
import { DelectMeeting } from '@/api/Meeting'
import { getItem } from '@/utils/auth'
export default {
  name: 'MeetingListChid',
  components: { myMeetingDetails },
  inject: ['getList'],
  props: {
    myData: {
      type: null,
      default: null
    },
    cycleMeet: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      // 弹窗是否显示
      dialogshow: false,
      mouth: '',
      day: '',
      time: '',
      timEnd: '',
      btnRShow: true,
      delbtnShow: true,
      updbtnShow: true,
      sparebtnShow: false,
      ModifyData: {},
      // 周期会议时间存放
      cycleTime: [],
      // 是否  过期
      overdue: false,
      swipeWidth: 67,
      flg: 0,
      roomFlg: 0,
      roomName: ''
    }
  },
  computed: {},
  watch: {
    myData: {
      handler(nVal) {
        this.getAllDataFunc()
      },
      immediate: true,
      deep: true
    },
    cycleMeet(nVal) {
      if (nVal) {
        this.getgroupDataFunc()
      } else {
        this.getAllDataFunc()
      }
    }
  },
  created() {
    if (this.cycleMeet) {
      this.getgroupDataFunc()
    } else {
      this.getAllDataFunc()
    }
  },
  mounted() {

  },
  methods: {
    // 周期会议室
    getgroupDataFunc() {
      this.mouth = this.$moment(this.myData[0].meeting_time_s).format('MM')
      this.day = this.$moment(this.myData[0].meeting_time_s).format('DD')
      this.time = this.$moment(this.myData[0].meeting_time_s).format('HH:mm')
      this.timEnd = this.$moment(this.myData[0].meeting_time_e).format('HH:mm')
      for (var i = 0; i < this.myData.length; i++) {
        if (this.$moment(this.myData[i].meeting_time_e).format('YYYY-MM-DD HH:mm:ss') > this.$moment().format('YYYY-MM-DD HH:mm:ss')) {
          this.flg = this.flg + 1
        }
        if (this.flg === 1) {
          this.time = this.$moment(this.myData[i].meeting_time_s).format('HH:mm')
          this.timEnd = this.$moment(this.myData[i].meeting_time_e).format('HH:mm')
          this.roomName = this.myData[i].room_code
          this.roomFlg = 1
        }
      }
      const userData = ['2018054', '2019001', '2016085', '2019006']
      userData.push(this.myData[0].create_user)
      const user = userData.filter(item => item === getItem().Login_UserCode)
      // console.log(user)
      // this.btnRShow = true
      if (user.length === 0) {
        this.btnRShow = false
        this.updbtnShow = false
        this.delbtnShow = false
        this.swipeWidth = 0
      } else {
        this.btnRShow = true
        this.delbtnShow = true
        // 会议结束时间 小于 当前时间
        if (this.$moment(this.myData[this.myData.length - 1].meeting_time_e).format('YYYY-MM-DD HH:mm:ss') < this.$moment().format('YYYY-MM-DD HH:mm:ss')) {
          this.updbtnShow = false
          this.swipeWidth = 67
        } else {
          this.updbtnShow = true
          this.swipeWidth = 136
        }
      }
      const moments = this.myData.map(d => this.$moment(this.$moment(d.meeting_time_e).format('YYYY-MM-DD')))
      // 获取当前时间
      const nowTime = this.$moment(new Date()).format('YYYY-MM-DD')
      this.cycleTime = []
      moments.filter(value => {
        let overdue = true
        if (this.$moment(value._i).isAfter(nowTime) || this.$moment(nowTime).isSame(value._i)) {
          overdue = false
        }
        this.cycleTime.push({
          overdue: overdue,
          time: value._i
        })
      })
      // 获取最大日期
      const maxDate = this.$moment.max(moments)._i
      // 最小日期
      const minDate = this.$moment.min(moments)._i
      const num = this.myData.map(e => e.meeting_num.toString())
      this.ModifyData.meeting_content = this.myData[0].meeting_content
      this.ModifyData.meeting_group = this.myData[0].meeting_group
      this.ModifyData.meeting_num = num
      this.ModifyData.meeting_time_e = maxDate
      this.ModifyData.meeting_time_s = minDate
      this.ModifyData.meeting_time_e_t = this.$moment(this.myData[0].meeting_time_e).format('HH:mm:ss')
      this.ModifyData.meeting_time_s_t = this.$moment(this.myData[0].meeting_time_s).format('HH:mm:ss')
      this.ModifyData.meeting_title = this.myData[0].meeting_title
      this.ModifyData.meeting_users = this.myData[0].meeting_users
      this.ModifyData.meeting_value = this.myData[0].meeting_value
      // this.ModifyData.register_date = this.myData[0].create_user
      this.ModifyData.register_user = this.myData[0].register_user
      this.ModifyData.room_code = this.myData[0].room_code
      if (this.roomFlg === 1) {
        this.ModifyData.room_code = this.roomName
      }
      this.ModifyData.user_name = this.myData[0].user_name
      this.ModifyData.meeting_week = this.myData[0].meeting_week
      this.ModifyData.meeting_week_num = this.myData[0].meeting_week_num
      this.ModifyData.create_user = this.myData[0].create_user
      this.ModifyData.meeting_group = this.myData[0].meeting_group
    },
    // 单次会议室
    getAllDataFunc() {
      this.mouth = this.$moment(this.myData.meeting_time_s).format('MM')
      this.day = this.$moment(this.myData.meeting_time_s).format('DD')
      this.time = this.$moment(this.myData.meeting_time_s).format('HH:mm')
      this.timEnd = this.$moment(this.myData.meeting_time_e).format('HH:mm')
      const userData = ['2018054', '2019001', '2016085', '2019006']
      userData.push(this.myData.create_user)
      const user = userData.filter(item => item === getItem().Login_UserCode)
      if (user.length === 0) {
        this.btnRShow = false
        this.updbtnShow = false
        this.delbtnShow = false
        this.swipeWidth = 0
      // 当前用户
      } else {
        this.btnRShow = true
        this.delbtnShow = true
        // 会议结束时间 小于 当前时间
        if (this.$moment(this.myData.meeting_time_e).format('YYYY-MM-DD HH:mm:ss') < this.$moment().format('YYYY-MM-DD HH:mm:ss')) {
          this.updbtnShow = false
          this.swipeWidth = 67
        } else {
          this.updbtnShow = true
          this.swipeWidth = 136
        }
      }
      // 获取当前时间
      const nowTime = this.$moment(new Date()).format('YYYY-MM-DD')
      this.cycleTime = []

      const time = this.$moment(this.myData.meeting_time_s).format('YYYY-MM-DD')
      this.overdue = !!this.$moment(time).isBefore(nowTime)
      if (this.$moment(time).isBefore(nowTime)) {
        this.overdue = true
      } else {
        this.overdue = false
      }
      var num = []
      if (this.myData.meeting_num) {
        num.push(this.myData.meeting_num.toString())
      }
      this.ModifyData.meeting_content = this.myData.meeting_content
      this.ModifyData.meeting_group = this.myData.meeting_group
      this.ModifyData.meeting_num = num
      this.ModifyData.meeting_time_e = this.$moment(this.myData.meeting_time_s).format('YYYY-MM-DD')
      this.ModifyData.meeting_time_s = this.$moment(this.myData.meeting_time_s).format('YYYY-MM-DD')
      this.ModifyData.meeting_time_e_t = this.$moment(this.myData.meeting_time_e).format('HH:mm:ss')
      this.ModifyData.meeting_time_s_t = this.$moment(this.myData.meeting_time_s).format('HH:mm:ss')
      this.ModifyData.meeting_title = this.myData.meeting_title
      this.ModifyData.meeting_users = this.myData.meeting_users
      this.ModifyData.meeting_value = this.myData.meeting_value
      // this.ModifyData.register_date = this.myData[0].create_user
      this.ModifyData.register_user = this.myData.register_user
      this.ModifyData.room_code = this.myData.room_code
      this.ModifyData.user_name = this.myData.user_name
      this.ModifyData.meeting_week = this.myData.meeting_week
      this.ModifyData.meeting_week_num = this.myData.meeting_week_num
      this.ModifyData.create_user = this.myData.create_user
      this.ModifyData.meeting_group = this.myData.meeting_group
    },
    delMeetingFunc() {
      var _this = this
      const numbar = []
      this.ModifyData.meeting_num.forEach(element => {
        numbar.push({ meeting_num: element })
      })
      DelectMeeting(numbar, function(res) {
        if (res.code === 0) {
          _this.getList()
          _this.$toast.success('删除成功')
        } else {
          _this.$toast.fail('删除失败')
        }
      })
    },
    meetingDetail() {
      this.$router.push({
        path: '/index/myMeetingDetails',
        query: this.ModifyData
      })
    },
    ModifyFunc() {
      this.$router.push(
        {
          path: '/MeetingReservation',
          query: {
            type: 'updata',
            cycleMeet: this.cycleMeet,
            data: this.ModifyData
          }
        }
      )
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
/deep/.van-dialog__header{
  padding: 16px 0;
}
.red-line{
    text-decoration: solid;
    text-decoration-color: red;
    text-decoration-line: line-through;
}
.my-btn{
    border: 0;
    height: 94.27px;
    line-height: 94.27px ;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    width: 70px;
}
.my-btn-bg-bule{
    background: #5078ff;
}
.my-btn-bg-red{
     background: #ff6565;
}
.myMeeting-bg{
    display: flex;
    background: #ffffff;
    padding: 10px;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    span{
      margin-right:5px ;
    }
    .font-more{
        text-align: right;
    }
    &>.myMeeting-l-font{
      font-size: 14px;
      color: #797979;
      width: 100%;
      margin-left: 10px;
      line-height: 24px;
      &>.myMeeting-font-tit{
        display: flex;
        justify-content: space-between;
      }
    }
    &>.myMeeting-circular{
      width: 30px;
      margin-top: 7px;
      &>.circular{
        display: block;
        width: 10px;
        height: 10px;
        margin: 0 auto;
        border-radius: 50%;
        background: #3473b0;
      }
    }
    &>.myMeeting-l{
        width: 100%;
        border-bottom: #f8f8f8 solid 1px;
        &>h2{
                color: #060606;
                font-size:16px;
                margin-bottom:8px;
            }
             &>h3{
                color: #959595;
                font-size:14px;
                font-weight: initial;
                margin-top: .0;
               margin-bottom: 8px;
                   text-align: left;
            }
      }
    &>.myMeeting-r{
        width:90px;
        position: relative;
        padding: 0 10px;
        &>.time{
            z-index: 1;
            position: relative;
            &>h1{
                color: #fff;
                text-align: center;
                font-size: 22px;
                margin: 19px 0 0 0;
                    font-weight: initial;
            }
              &>h2{
                color: #fff;
                text-align: center;
                font-size:17px;
                font-weight: initial;
                 margin: 0px 0 0 0;
            }
        }
        &>.imgBg{
            padding-right: 15px;
            position: absolute;
            z-index: 0;
            top: 14px;
            &>img{
                width: 100%;
            }
        }
    }
}
</style>
